import React from 'react';
import PeriodPicker from './PeriodSelection/PeriodPicker/PeriodPicker';
import { useAppSelector } from '../../redux/hooks';
import styles from "../../assets/styles/components/header.module.scss";
import logo from '../../assets/images/LogoMevaker.png';
import logoContrast from '../../assets/images/LogoMevaker-contrast.png';
import logo_mobile from '../../assets/images/LogoMevakerMobile.png';
import logo_mobileContrast from '../../assets/images/LogoMevakerMobile-contrast.png';
import Const from 'const.json';

const Header: React.FC = () => {

    const { isContrast } = useAppSelector(state => state.general);

    return (
        <div className={`${styles.header} d-flex w-100 align-items-center`} >
            <img src={isContrast ? logoContrast : logo} alt={Const.textOfLogoMevaker} className='d-none d-md-block'/>
            <img src={isContrast ? logo_mobileContrast : logo_mobile} alt={Const.textOfLogoMevaker} className='d-md-none'/>
            <span className={`${styles.border} mx-3`}></span>
            <h1 className='mb-0 d-none d-md-block'>{Const.publicComplaintsSnapshot}</h1>
            <div className="me-auto">
                <PeriodPicker />
            </div>
        </div>
    );
};

export default Header;

